import React, { useEffect, useState } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [platformDropdownOpen, setPlatformDropdownOpen] = useState(false);
  const [companyDropdownOpen, setCompanyDropdownOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navItems = ['Contact'];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm border-b border-line py-3' : 'bg-white border-b border-line py-4'}`} data-id="element-801" data-mp="f02a7iwss4v9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-802" data-mp="ozt6nq4x4txz">
        <div className="flex justify-between items-center" data-id="element-803" data-mp="dfz63log9bjp">
          {/* Logo Area */}
          <div className="flex items-center" data-id="element-804" data-mp="hhaz816j8ewn">
            <a href="/" className="flex items-center" aria-label="SyNeural home" data-id="element-805" data-mp="hi2h6977ie4g">
              <img src="https://cdn.magicpatterns.com/uploads/vBy52qowPNFNY53vkUADE7/SyNeural-logo-no-tagline-half-size.svg" alt="SyNeural" className={`w-auto transition-[height] duration-200 ease-out ${isScrolled ? 'h-8' : 'h-10'}`} data-id="element-806" data-mp="mg4admycjttn" />
            </a>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8" data-id="element-807" data-mp="10dsma5afrqmk">
            <ul className="flex items-center gap-6" data-id="element-808" data-mp="157f0w305u4l0">
              {/* Platform Dropdown */}
              <li className="relative" data-id="element-809" data-mp="1a4nahf78t0an">
                <button onMouseEnter={() => setPlatformDropdownOpen(true)} onMouseLeave={() => setPlatformDropdownOpen(false)} className="text-sm font-medium text-ink-muted hover:text-navy transition-colors flex items-center gap-1" aria-expanded={platformDropdownOpen} data-id="element-810" data-mp="1a7sy0q083u49">
                  Products
                  <ChevronDown size={14} className={`transition-transform ${platformDropdownOpen ? 'rotate-180' : ''}`} data-id="element-811" data-mp="pet4ssfefuf3" />
                </button>

                <AnimatePresence data-id="element-812" data-mp="zd8uqs2owxn0">
                  {platformDropdownOpen && <motion.div initial={{
                  opacity: 0,
                  y: -10
                }} animate={{
                  opacity: 1,
                  y: 0
                }} exit={{
                  opacity: 0,
                  y: -10
                }} transition={{
                  duration: 0.2
                }} onMouseEnter={() => setPlatformDropdownOpen(true)} onMouseLeave={() => setPlatformDropdownOpen(false)} className="absolute top-full left-0 mt-2 w-80 bg-white rounded-lg shadow-lg border border-line py-2" data-id="element-813" data-mp="1d4ng35k2lax8">
                      <a href="/human-capability" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-814" data-mp="1pou5b4q45rkm">
                        <div className="font-semibold" data-id="element-815" data-mp="1gqiep2p8yts6">Human Capability Platform</div>
                        <div className="text-xs text-ink-muted" data-id="element-816" data-mp="1krc7oahjqyrx">
                          Reasoning, judgment & leadership readiness
                        </div>
                      </a>
                      <div className="ml-4 border-l border-line" data-id="element-817" data-mp="1bpuqspwbet26">
                        <a href="/cji" className="block pl-4 pr-4 py-1.5 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-818" data-mp="313zkh87flil4">
                          <span className="font-semibold" data-id="element-819" data-mp="15zt722araj8o">CJI</span>
                          <span className="text-ink-muted" data-id="element-820" data-mp="1129k8dzzsy54"> · Civic Judgment Index</span>
                        </a>
                        <a href="/ncji" className="block pl-4 pr-4 py-1.5 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-821" data-mp="wzmwopactzdq">
                          <span className="font-semibold" data-id="element-822" data-mp="n30c81lxxac8">NCJI</span>
                          <span className="text-ink-muted" data-id="element-823" data-mp="ib05nqbd7j6o"> · Neurocognitive Index</span>
                        </a>
                      </div>
                      <a href="/semantic-knowledge" className="block px-4 py-2 mt-1 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-824" data-mp="dcys1kwpkc2l">
                        <div className="font-semibold" data-id="element-825" data-mp="4dldidtq8xb0">Semantic Knowledge Platform</div>
                        <div className="text-xs text-ink-muted" data-id="element-826" data-mp="3vitr6c0midr6">
                          Connected evidence & knowledge graphs
                        </div>
                      </a>
                      <div className="border-t border-line my-2" data-id="element-827" data-mp="2fxj7ucldwu85"></div>
                      <a href="/solutions" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-828" data-mp="2kxxh1xyq2a7r">
                        <div className="font-semibold" data-id="element-829" data-mp="1sakrdex9lma8">Solutions</div>
                        <div className="text-xs text-ink-muted" data-id="element-830" data-mp="1x8cuz679uwu9">
                          Applications & Use Cases
                        </div>
                      </a>
                    </motion.div>}
                </AnimatePresence>
              </li>

              {/* Company Dropdown */}
              <li className="relative" data-id="element-831" data-mp="19jjtku7vrws9">
                <button onMouseEnter={() => setCompanyDropdownOpen(true)} onMouseLeave={() => setCompanyDropdownOpen(false)} className="text-sm font-medium text-ink-muted hover:text-navy transition-colors flex items-center gap-1" data-id="element-832" data-mp="19irz5mq0s53k">
                  Company
                  <ChevronDown size={14} className={`transition-transform ${companyDropdownOpen ? 'rotate-180' : ''}`} data-id="element-833" data-mp="2qlcl4qqivi1m" />
                </button>

                <AnimatePresence data-id="element-834" data-mp="1xwnj8phn78ot">
                  {companyDropdownOpen && <motion.div initial={{
                  opacity: 0,
                  y: -10
                }} animate={{
                  opacity: 1,
                  y: 0
                }} exit={{
                  opacity: 0,
                  y: -10
                }} transition={{
                  duration: 0.2
                }} onMouseEnter={() => setCompanyDropdownOpen(true)} onMouseLeave={() => setCompanyDropdownOpen(false)} className="absolute top-full left-0 mt-2 w-60 bg-white rounded-lg shadow-lg border border-line py-2" data-id="element-835" data-mp="1xyrll2zw7zmz">
                      <a href="/about" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-836" data-mp="3bycvv52lvubb">
                        <div className="font-semibold" data-id="element-837" data-mp="8hmgw0p1q6xh">About</div>
                        <div className="text-xs text-ink-muted" data-id="element-838" data-mp="ddbcjsxy33oi">
                          Mission & Vision
                        </div>
                      </a>
                      <a href="/research" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-839" data-mp="3ob9nygbno51">
                        <div className="font-semibold" data-id="element-840" data-mp="w5non7eehjbu">Research</div>
                        <div className="text-xs text-ink-muted" data-id="element-841" data-mp="w6yst8brct3h">
                          Architecture & priorities
                        </div>
                      </a>
                      <a href="/roadmap" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-842" data-mp="2ng8zribfuqdd">
                        <div className="font-semibold" data-id="element-843" data-mp="2eiow62q3shzl">Roadmap</div>
                        <div className="text-xs text-ink-muted" data-id="element-844" data-mp="3b63clzvrcexm">
                          Where our research is going
                        </div>
                      </a>
                      <a href="/partnerships" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-845" data-mp="325x1ulrg1t25">
                        <div className="font-semibold" data-id="element-846" data-mp="1qrji9t3q3zrx">Partnerships</div>
                        <div className="text-xs text-ink-muted" data-id="element-847" data-mp="1ls6logn1vec5">
                          Collaborate with Us
                        </div>
                      </a>
                    </motion.div>}
                </AnimatePresence>
              </li>

              {navItems.map(item => <li key={item} data-id="element-848" data-mp="1lmpf9825twwe">
                  <a href={`/${item.toLowerCase()}`} className="text-sm font-medium text-ink-muted hover:text-navy transition-colors" data-id="element-849" data-mp="1llnrq43yjhxs">
                    {item}
                  </a>
                </li>)}
            </ul>
            <div className="w-px h-5 bg-line" data-id="element-850" data-mp="1zcsydq5qtahm"></div>
            <a href="/contact" className="bg-navy hover:bg-navy-light text-white text-sm font-medium px-5 py-2.5 rounded-md transition-colors shadow-sm whitespace-nowrap" data-id="element-851" data-mp="24cxevg6ni57u">
              Request Demo
            </a>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="lg:hidden text-ink-dark p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-852" data-mp="expjrw0l5uuq">
            {mobileMenuOpen ? <X size={24} data-id="element-853" data-mp="2yvpnw1972rws" /> : <Menu size={24} data-id="element-854" data-mp="2yv7jghcdp7ds" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav Drawer */}
      <AnimatePresence data-id="element-855" data-mp="32xb6m38eu0ew">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden bg-white border-b border-line overflow-hidden" data-id="element-856" data-mp="32zxek3z7qhxn">
            <div className="px-4 pt-2 pb-6 space-y-1 shadow-inner" data-id="element-857" data-mp="3mmd7hjsh35z6">
              {/* Platform submenu */}
              <div className="border-b border-line pb-2 mb-2" data-id="element-858" data-mp="3qp9pp9e3p02l">
                <div className="text-xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2" data-id="element-859" data-mp="3vnkv97xd4of0">
                  Products
                </div>
                <a href="/human-capability" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-860" data-mp="ejvqova7lkpi">
                  Human Capability Platform
                </a>
                <a href="/cji" className="block pl-7 pr-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-861" data-mp="kmhifkf7qv1">
                  CJI
                </a>
                <a href="/ncji" className="block pl-7 pr-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-862" data-mp="nkbsm0bb0js9">
                  NCJI
                </a>
                <a href="/semantic-knowledge" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-863" data-mp="1baekafbb3nqc">
                  Semantic Knowledge Platform
                </a>
                <a href="/solutions" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-864" data-mp="2vsysnta0vgwo">
                  Solutions
                </a>
              </div>

              {/* Company submenu */}
              <div className="border-b border-line pb-2 mb-2" data-id="element-865" data-mp="2ro8xy7r3o8dc">
                <div className="text-xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2" data-id="element-866" data-mp="2cumic47dk0zi">
                  Company
                </div>
                <a href="/about" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-867" data-mp="b27smiyl9s8j">
                  About
                </a>
                <a href="/research" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-868" data-mp="20gr0ogo32pul">
                  Research
                </a>
                <a href="/roadmap" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-869" data-mp="25gd8ubp21fwj">
                  Roadmap
                </a>
                <a href="/partnerships" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-870" data-mp="2t5ocq21pbqew">
                  Partnerships
                </a>
              </div>

              {navItems.map(item => <a key={item} href={`/${item.toLowerCase()}`} className="block px-3 py-3 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-871" data-mp="vb0r9afglzg3">
                  {item}
                </a>)}
              <div className="pt-4 px-3" data-id="element-872" data-mp="clcemxfh75pj">
                <a href="/contact" onClick={() => setMobileMenuOpen(false)} className="block w-full text-center bg-navy text-white font-medium px-5 py-3 rounded-md shadow-sm" data-id="element-873" data-mp="cmds18jys4af">
                  Request Demo
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}